import { render, staticRenderFns } from "./LeadBoardDeal.vue?vue&type=template&id=b99dac08&"
import script from "./LeadBoardDeal.vue?vue&type=script&lang=js&"
export * from "./LeadBoardDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports